module.exports = __webpack_public_path__ + "img/Malleolo_MED_SX.50161b44.png";